<template>
  <div class="analysis-container flex1" ref="fullflag">
    <div class="flex">
      <div class="ana-header flex1">
        <!-- 缩放图标 -->
        <div v-if="!isFullFlag">
          <img src="@/assets/img/fullscreen.png" class="iconBig" @click="doFull" />
        </div>
        <div v-else>
          <img src="@/assets/img/ScaleIcon.png" class="iconBig" @click="doFull" />
        </div>
      </div>
    </div>

    <dashboard style="overflow: auto" />
  </div>
</template>

<script>
import dashboard from './components/dashboard.vue';
export default {
  components: { dashboard },
  data() {
    return {
      list: [],
      params: { page: 1, c_type: '', c_name: '' },
      count: 0,
      total: 0,
      showDia: false,
      searchForm: this.$getForm('reportSearch'),
      editData: {},
      remoteFuncs: {},
      isFullFlag: false,
      iconFlag: true,
    };
  },
  created() {
    this.getList();
  },
  computed: {},
  mounted() {
    // console.log(this.$refs);
  },
  methods: {
    doFull() {
      this.iconFlag = false;
      const element = this.$refs.fullflag; //指定全屏区域元素

      if (!this.isFullFlag) {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
        console.log('已全屏！');
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        console.log('已还原！');
      }
      this.isFullFlag = !this.isFullFlag;
    },
    toPatrol(row) {
      this.$local.save('company', {
        c_company_num: row.c_company_num,
        c_name: row.c_name,
      });
    },
    changtime(time) {
      return time.substring(0, 10);
    },
    cancel() {
      this.showDia = false;
      this.resetSearch();
    },
    getList() {
      this.$post('/reportcount/reportlist', this.params).then((res) => {
        console.log(res, '11111111111111');
        this.list = res.data.list;
        this.count = res.data.count;
      });
    },

    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;
          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.analysis-container {
  background: url('~@/assets/img/analysis/background.png');
  display: flex;
  flex-direction: column;
  ::-webkit-scrollbar {
    width: 5px; /*对垂直流动条有效*/
    height: 5px; /*对水平流动条有效*/
  }

  /*定义滚动条的轨道颜色、内阴影及圆角*/
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
  }

  /*定义滑块颜色、内阴影及圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 7px;
    // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #e8e8e8;
  }



  /*定义右下角汇合处的样式*/
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  // ::-webkit-scrollbar-thumb:window-inactive {
  //   background: gray;
  // }
  ::-webkit-scrollbar-thumb:hover {
    cursor: pointer;
    background: #ccc;
  }
  ::-webkit-scrollbar-thumb:active {
    background: #999;
  }
  overflow-x: hidden;
}
.ana-header {
  width: 100%;
  min-width: 980px;
  height: 76px;
  background: url('~@/assets/img/analysis/header.png') no-repeat center;
  background-size: auto 100%;
}
.iconBig {
  width: 30;
  height: 30px;
  object-fit: contain;
  cursor: pointer;
  display: flex;
  margin-left: auto;
  margin-top: 0.7%;
}
</style>
